import { render, staticRenderFns } from "./FiltersSet.vue?vue&type=template&id=a56ab5a0&scoped=true&"
import script from "./FiltersSet.vue?vue&type=script&lang=js&"
export * from "./FiltersSet.vue?vue&type=script&lang=js&"
import style0 from "./FiltersSet.vue?vue&type=style&index=0&id=a56ab5a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a56ab5a0",
  null
  
)

export default component.exports